// import the library
import { library } from "@fortawesome/fontawesome-svg-core";

// import your icons
import {
	faPlane,
	faCalendarAlt,
	faFlagUsa,
	faDna,
	faBalanceScaleRight,
	faTools,
	faGlobeAmericas,
	faSearch,
	faHome,
	faPencilAlt,
	faList,
	faLink,
	faUserFriends,
	faTrashAlt,
	faCopyright,
	faEdit,
	faUserCircle,
	faHardHat,
	faImage,
	faDollarSign,
	faChevronDown,
	faChevronUp,
	faHashtag,
	faEnvelope,
	faClock,
	faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";

library.add(
	faPlane,
	faCalendarAlt,
	faFlagUsa,
	faDna,
	faBalanceScaleRight,
	faTools,
	faGlobeAmericas,
	faSearch,
	faHome,
	faPencilAlt,
	faList,
	faLink,
	faUserFriends,
	faTrashAlt,
	faCopyright,
	faEdit,
	faUserCircle,
	faHardHat,
	faImage,
	faDollarSign,
	faChevronUp,
	faChevronDown,
	faHashtag,
	faEnvelope,
	faClock,
	faQuestionCircle
);
